import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyImport, LazyAction, registerLazyOrchestrator } from 'owa-bundling';
import { onInitializeFolderTreeCompleted } from 'owa-folders';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "QuickSteps" */ './lazyIndex'),
    { name: 'QuickSteps' }
);

// Lazy action
export const lazyAddQuickStep: LazyImport<typeof lazyIndex.addQuickStep, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.addQuickStep);
export const lazyRemoveQuickStep: LazyImport<typeof lazyIndex.removeQuickStep, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.removeQuickStep);
export const lazyMoveQuickStep: LazyImport<typeof lazyIndex.moveQuickStep, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.moveQuickStep);
export const lazySetQuickStepsRunOnce: LazyAction<
    typeof lazyIndex.setQuickStepsRunOnceMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setQuickStepsRunOnceMutator);
export const lazyGetQuickStepActionsByHotkey: LazyImport<
    typeof lazyIndex.getQuickStepActionsByHotkey,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getQuickStepActionsByHotkey);
export const lazyGetQuickStepActionsById: LazyImport<
    typeof lazyIndex.getQuickStepActionsById,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getQuickStepActionsById);

registerLazyOrchestrator(
    onInitializeFolderTreeCompleted,
    lazyModule,
    m => m.onInitializeFolderTreeCompletedOrchestrator
);
